import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Show, SignIn, SignUp } from "@clerk/react";
import { Toaster } from "sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Manager from "@/pages/Manager";
import Charter from "@/pages/Charter";
import Products from "@/pages/Products";
import Contacts from "@/pages/Contacts";
import Segments from "@/pages/Segments";
import Campaigns from "@/pages/Campaigns";
import CampaignDetail from "@/pages/CampaignDetail";
import Inbox from "@/pages/Inbox";
import Exceptions from "@/pages/Exceptions";
import Meetings from "@/pages/Meetings";
import AuditSpend from "@/pages/AuditSpend";
import Settings from "@/pages/Settings";
import Unsubscribe from "@/pages/Unsubscribe";
import Waitlist from "@/pages/Waitlist";
import Calls from "@/pages/Calls";
import Studio from "@/pages/Studio";
import GoLive from "@/pages/GoLive";
import Guide from "@/pages/Guide";
import Launchpad from "@/pages/Launchpad";
import OnePlace from "@/pages/OnePlace";
import LaunchReview from "@/pages/LaunchReview";
import { MasaBrand } from "@/components/MasaBrand";

const AuthShell = ({ children }) => (
  <div className="min-h-screen grid lg:grid-cols-2 bg-[#0A0A0A]">
    <div className="hidden lg:flex flex-col justify-between p-12 border-r border-border grid-bg">
      <MasaBrand size="lg" />
      <div>
        <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#007AFF] mb-4">Your AI sales & marketing autopilot</div>
        <h1 className="text-5xl font-extrabold leading-[1.05] max-w-md">Drop in the offer. MaSa builds and runs the campaign.</h1>
        <p className="text-zinc-400 mt-5 max-w-md text-sm leading-relaxed">Consent-first outreach, grounded replies and an exception-only workspace. Humans decide; agents execute within bounds.</p>
      </div>
      <div className="font-mono text-[11px] text-zinc-500">MaSa · an AI Agent from Specia AI</div>
    </div>
    <div className="flex items-center justify-center p-6">{children}</div>
  </div>
);

const Protected = ({ children }) => (
  <>
    <Show when="signed-in"><Layout>{children}</Layout></Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
  </>
);

const P = (el) => <Protected>{el}</Protected>;

function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#121212", border: "1px solid #27272A" } }} />
        <Routes>
          <Route path="/sign-in/*" element={<AuthShell><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthShell>} />
          <Route path="/sign-up/*" element={<AuthShell><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthShell>} />
          <Route path="/unsubscribe/:token" element={<Unsubscribe />} />
          <Route path="/waitlist" element={<Waitlist />} />
          <Route path="/" element={P(<Dashboard />)} />
          <Route path="/manager" element={P(<Manager />)} />
          <Route path="/charter" element={P(<Charter />)} />
          <Route path="/products" element={P(<Products />)} />
          <Route path="/contacts" element={P(<Contacts />)} />
          <Route path="/segments" element={P(<Segments />)} />
          <Route path="/campaigns" element={P(<Campaigns />)} />
          <Route path="/campaigns/:id" element={P(<CampaignDetail />)} />
          <Route path="/inbox" element={P(<Inbox />)} />
          <Route path="/exceptions" element={P(<Exceptions />)} />
          <Route path="/meetings" element={P(<Meetings />)} />
          <Route path="/calls" element={P(<Calls />)} />
          <Route path="/golive" element={P(<GoLive />)} />
          <Route path="/one" element={P(<OnePlace />)} />
          <Route path="/launchpad" element={P(<Launchpad />)} />
          <Route path="/launchpad/:id" element={P(<LaunchReview />)} />
          <Route path="/studio" element={P(<Studio />)} />
          <Route path="/guide" element={P(<Guide />)} />
          <Route path="/audit" element={P(<AuditSpend />)} />
          <Route path="/settings" element={P(<Settings />)} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}

export default App;
